import { FC } from "react";
// 方法
import { useLayoutContext } from '../../../PageLayout/context/LayoutContext';
import { renderEnumName } from '../../../utils/renderUtils';
import { filterEmptyValue } from '../../../utils/utils';
// 常量
import { TABLE_COLUMN_EMPTY } from '../../../constants/constant';
import { OptionItemProps } from "../../interface";

const OptionItem: FC<OptionItemProps> = props => {
  const { statue, label, statues, name, enumCode, isImage, isCopy, flex, labelWidth, record, render, } = props;
  const { enumData } = useLayoutContext();
  /** 状态是否在状态集 */
  if (Array.isArray(statues) && statue) {
    if (!statues.includes(statue)) return null;
  }
  const renderValue = () => {
    if (!name || !record) return TABLE_COLUMN_EMPTY;
    const colValue = record[name];
    if (enumCode) {
      const enumItem = enumData?.[enumCode]?.items ?? [];
      return renderEnumName(colValue, enumItem);
    }
    return filterEmptyValue(colValue);
  };

  return (
    <div className="column-line-col">
      {
        !!label && <div className="column-line-col-label">{label}:</div>
      }
      <div className="column-line-col-text">{renderValue()}</div>
    </div>
  );
};

export default OptionItem;
